import { api } from "boot/axios";

export default () => {
  //Get Custom Signal
  const getCustomSignal = async () => {
    try {
      const data = await api.get("/custom-signals/v2/custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal
  const postCustomSignal = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/v2/custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  //Get Custom Signal RSI
  const getCustomSignalSMA = async () => {
    try {
      const data = await api.get("/custom-signals/sma-custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal RSI
  const postCustomSignalSMA = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/sma-custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Custom Signal RSI
  const getCustomSignalRSI = async () => {
    try {
      const data = await api.get("/custom-signals/rsi-custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal RSI
  const postCustomSignalRSI = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/rsi-custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Custom Signal MACD
  const getCustomSignalMACD = async () => {
    try {
      const data = await api.get("/custom-signals/macd-custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal MACD
  const postCustomSignalMACD = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/macd-custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //Get Custom Signal EMA
  const getCustomSignalEMA = async () => {
    try {
      const data = await api.get("/custom-signals/ema-custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal EMA
  const postCustomSignalEMA = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/ema-custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Custom Signal SuperTrend
  const getCustomSignalSuperTrend = async () => {
    try {
      const data = await api.get("/custom-signals/supertrend-custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal SuperTrend
  const postCustomSignalSuperTrend = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/supertrend-custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Custom Signal DI
  const getCustomSignalDI = async () => {
    try {
      const data = await api.get("/custom-signals/di-custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal DI
  const postCustomSignalDI = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/di-custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get Custom Signal PSAR
  const getCustomSignalPSAR = async () => {
    try {
      const data = await api.get("/custom-signals/psar-custom-pro/");
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Post Custom Signal PSAR
  const postCustomSignalPSAR = async (customSignals) => {
    try {
      const data = await api.post(
        "/custom-signals/psar-custom-pro/",
        customSignals
      );
      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  const customSignalSetup = async (customSignalSetupData) => {
    try {
      const data = await api.post(
        "/custom-signals/custom-pro/setup/",
        customSignalSetupData
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  // DEPRECATED
  // const getSavedCustomSignal = async () => {
  //   try {
  //     const data = await api.get("/custom-signals/custom-pro/setup/");
  //     return data;
  //   } catch (error) {
  //     throw error;
  //   }
  // };
  const getSavedCustomSignalV2savedModels = async () => {
    try {
      const data = await api.get(`custom-signals/v2/custom-pro/new/save/`);
      return data;
    } catch (error) {
      throw error;
    }
  };
  const getSavedCustomSignalV2Results = async (model_id) => {
    try {
      const data = await api.get(
        `custom-signals/v2/custom-pro/new/results/${model_id}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const loadSavedModel = async (modelId) => {
    try {
      const data = await api.get(
        `/custom-signals/custom-pro/setup/results/${modelId}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const deleteSavedModel = async (modelId) => {
    try {
      const data = await api.delete(
        `/custom-signals/custom-pro/setup/${modelId}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const deleteSavedModelV2 = async (modelId) => {
    try {
      const data = await api.delete(
        `custom-signals/v2/custom-pro/new/save/${modelId}`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const customSignalProV2New = async (payload) => {
    try {
      const data = await api.post("custom-signals/v2/custom-pro/new/", payload);
      return data;
    } catch (error) {
      throw error;
    }
  };
  const customSignalProV2NewSave = async (payload) => {
    try {
      const data = await api.post(
        "custom-signals/v2/custom-pro/new/save/",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  const customSignalProV2NewEdit = async (payload) => {
    try {
      const data = await api.patch(
        `custom-signals/v2/custom-pro/new/save/${payload.model_id}`,
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const BackTestEngineV2 = async (payload) => {
    try {
      const data = await api.post(
        "custom-signals/v2/custom-pro/backtest/",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
  return {
    customSignalProV2NewSave,
    customSignalProV2NewEdit,
    BackTestEngineV2,
    customSignalProV2New,
    deleteSavedModel,
    deleteSavedModelV2,
    loadSavedModel,
    getCustomSignal,
    postCustomSignal,
    getCustomSignalSMA,
    postCustomSignalSMA,
    getCustomSignalRSI,
    postCustomSignalRSI,
    getCustomSignalMACD,
    postCustomSignalMACD,
    getCustomSignalEMA,
    postCustomSignalEMA,
    getCustomSignalSuperTrend,
    postCustomSignalSuperTrend,
    postCustomSignalDI,
    getCustomSignalDI,
    postCustomSignalPSAR,
    getCustomSignalPSAR,
    customSignalSetup,
    // DEPRECATED
    // getSavedCustomSignal,
    getSavedCustomSignalV2Results,
    getSavedCustomSignalV2savedModels,
  };
};
